import React, { PropsWithChildren } from "react";
import { useNavigation } from "@react-navigation/native";
import { _goToRoot } from "router/helper";

import { View, StatusBar, SafeAreaView, Platform } from "react-native";

import HeaderLayout from "component/section/HeaderLayout";
import Button from "component/button/Button";
import Text from "component/typography/Text";

import { colors } from "asset/constant";
import { css } from "style";
import { sn } from "utils";

type HeaderT = {
  title: string;
  subTitle?: string;
  onBack?: () => void;
  hideBack?: boolean;
  hideHome?: boolean;
};

export default function Header(props: HeaderT) {
  const { title, subTitle, onBack, hideBack, hideHome } = props;
  const { goBack } = useNavigation();

  return (
    <HeaderLayout>
      <View
        style={{
          ...css.growContainer,
          ...css.rowCenterAlign,
        }}
      >
        {!hideBack && (
          <Button
            bgColor="transparent"
            onPress={onBack || goBack}
            square={45}
            icon={{ name: "left", color: colors.theme, size: 18 }}
          />
        )}
        <View style={css.growContainer} />
        <View>
          <Text
            size="xl"
            weight="bold"
            // color={colors.white}
            style={{ marginRight: 5 }}
          >
            {title}
          </Text>
          {subTitle && (
            <View
              style={Platform.select({ web: { marginTop: sn(5, 5, 8, 10) } })}
            >
              <Text
                size="sm"
                weight="bold"
                color={colors.text.muted}
                style={{ marginRight: 5 }}
              >
                {subTitle}
              </Text>
            </View>
          )}
        </View>
        {!hideHome && (
          <Button
            bgColor="transparent"
            onPress={_goToRoot}
            square={40}
            icon={{ name: "home", size: 25, color: colors.theme }}
            style={{ marginRight: 2, borderRadius: 16 }}
          />
        )}
      </View>
    </HeaderLayout>
  );
}
